var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail2Footer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4738 0.852291C20.2902 0.341653 19.8053 0 19.2617 0H4.73829C4.19467 0 3.70983 0.341653 3.52985 0.852291L0 10.7161C0 13.0819 1.91736 15.0032 4.28651 15.0032C6.65198 15.0032 8.573 13.0856 8.573 10.7161L5.66392 2.57156H10.7144V21.4284H5.57209V24H18.4279V21.4284H13.2856V2.57156H18.3434L15.427 10.7161C15.427 13.0819 17.3444 15.0032 19.7135 15.0032C22.079 15.0032 24 13.0856 24 10.7161L20.4738 0.852291ZM5.97613 10.7124H2.58954L4.28651 2.1895L5.97613 10.7124ZM18.0165 10.7124L19.64 2.56789L19.7172 2.1895L19.7906 2.56789L21.4031 10.7124H18.0165Z",
    fill: "#EF0074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2Footer);
export default __webpack_public_path__ + "static/media/email2_footer.491e014574df6cc1ec9c59005c527fd8.svg";
export { ForwardRef as ReactComponent };